import Importacao from './componentes/Importacao.vue';
import ImportacaoLista from './componentes/Lista.vue';

export default {
  path: 'importacao-projeto',
  component: Importacao,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: ImportacaoLista,
      name: 'importacao-projeto',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/importacao-projeto/rotas.js